<script setup lang="ts">
    import { computed, type HTMLAttributes } from 'vue';
    import { cn } from '@/lib/utils';
    import InputError from '@/components/InputError.vue';
    import { Label } from '@/components/ui/label';
    import { useI18n } from 'vue-i18n';

    const { t } = useI18n();

    interface Props {
        class?: HTMLAttributes['class'];
        form: any;
        name: string;
        label?: string;
        errorKey?: string;
    }

    const props = defineProps<Props>();

    const error = computed(() => props.form.errors?.[props.errorKey ?? props.name]);

    const label = computed(() => {
        return props.label ? t(props.label) : '';
    });
</script>

<template>
    <div :class="cn('flex flex-col gap-2', props.class)">
        <div
            v-if="label || $slots.label"
            class="flex items-center gap-2"
        >
            <Label :for="name"> {{ label }}</Label>
            <slot name="label" />
        </div>
        <div :class="cn('slot-wrapper', { 'has-error': error })">
            <slot />
        </div>
        <InputError :message="error" />
    </div>
</template>

<style scoped>
    /* .slot-wrapper.has-error > :first-child {
        border-color: var(--color-destructive);
    } */
</style>
